import { Constants } from '../constants';
import { Injectable, Inject } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class ApplicationRequesterDateAdapter extends NativeDateAdapter {
  Constants = Constants;

  parse(value: string): Date {
    let it = value.split('/');
    if (it.length === 1) {
      it = value.split('-');
    }
    return it.length === 3
      ? new Date(+it[2], +it[1] - 1, +it[0], 12)
      : new Date(value);
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}
